// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;

function MM_cmp_merge_two_stmts(props) {
  var onStmtSelected = props.onStmtSelected;
  var onCancel = props.onCancel;
  var stmt2 = props.stmt2;
  var stmt1 = props.stmt1;
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, React.createElement(Expln_React_Row.make, {
                            children: Caml_option.some(null)
                          }, React.createElement("span", {
                                style: {
                                  fontWeight: "bold"
                                }
                              }, "Merging "), React.createElement("span", undefined, MM_cmp_user_stmt.rndContText(stmt1.cont, undefined, undefined, undefined, undefined, undefined))), React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement(Button, {
                                            onClick: (function (param) {
                                                Curry._2(onStmtSelected, stmt1, stmt2);
                                              }),
                                            children: "Use this \u2192"
                                          })), React.createElement("td", undefined, stmt1.label + " [ " + stmt1.jstfText + " ]")), React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement(Button, {
                                            onClick: (function (param) {
                                                Curry._2(onStmtSelected, stmt2, stmt1);
                                              }),
                                            children: "Use this \u2192"
                                          })), React.createElement("td", undefined, stmt2.label + " [ " + stmt2.jstfText + " ]")))), React.createElement(Button, {
                            onClick: (function (param) {
                                Curry._1(onCancel, undefined);
                              }),
                            children: "Cancel"
                          })))
            });
}

var make = MM_cmp_merge_two_stmts;

exports.make = make;
/* react Not a pure module */
